import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// constants
import { SPACING, SPACING_HALF, SPACING_LEAST } from 'constants/spacing';
import { DRAWER_WIDTH } from 'components/Layouts/NavigationDrawer/styles';

// components
import AppBar from 'components/Layouts/AppBar';
import NavigationDrawer from 'components/Layouts/NavigationDrawer';
import ThemeDrawer from 'components/Layouts/ThemeDrawer';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

// icons
import SettingsIcon from 'components/shared/icons/Settings';

// lib
import withAuth from 'lib/withAuth';

// hooks
import { useIsAdmin } from 'providers/UserProvider';
import { useIsCustomer } from 'providers/CustomerProvider';
import { useProfile } from 'hooks/admin';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    backgroundColor: theme.palette.common.white,
  },
  toolbar: theme.mixins.toolbar,
  content: ({ isAdmin,isCustomer }) => {
    return {
      width: isAdmin|| isCustomer ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
      padding: theme.spacing(SPACING, SPACING_HALF),
      height: '100%',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: theme.spacing(SPACING, SPACING_LEAST),
      },
    };
  },
  themeButton: {
    position: 'fixed',
    bottom: theme.spacing(SPACING_HALF),
    right: theme.spacing(SPACING_HALF),
    zIndex: theme.zIndex.speedDial,
  },
}));

/**
 * @component DefaultTemplate
 */
function DefaultTemplate({ children }) {
  const isAdmin = useIsAdmin();
  const isCustomer = useIsCustomer()
  const classes = useStyles({ isAdmin, isCustomer });
  const { status } = useProfile();

  const [openThemeDrawer, setOpenThemeDrawer] = useState(false);


  return (
    <div className={classes.root}>
      <AppBar />
      {isAdmin && <NavigationDrawer />}
      <div className={classes.content}>
        {isAdmin && <div className={classes.toolbar} />}
        {isAdmin && <div className={classes.themeButton}>
          <Tooltip title="تنظیمات">
            <Fab color="primary" size="small" onClick={() => setOpenThemeDrawer(true)}>
              <SettingsIcon color="inherit" />
            </Fab>
          </Tooltip>
        </div>}
        {isAdmin && <ThemeDrawer
          open={openThemeDrawer}
          setOpen={setOpenThemeDrawer}
          onClose={() => setOpenThemeDrawer(false)}
        />}
        {children}
      </div>
    </div>
  );
}

export default withAuth(DefaultTemplate);
